import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import { t } from '../lib/i18n.ts'

/**
 * Model output is untrusted (threat I3): no raw HTML (react-markdown escapes it), no images (classic exfiltration),
 * links only inside the app; external URLs are shown as plain text.
 */
export function Markdown({ text, onCite }: { text: string; onCite?: (n: number) => void }) {
  return (
    <div className="prose-ss">
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        skipHtml
        disallowedElements={['img', 'iframe', 'script', 'style']}
        unwrapDisallowed
        urlTransform={(url) => (url.startsWith('/') && !url.startsWith('//') ? url : '')}
        components={{
          a: ({ href, children }) => (href ? <a className="text-caneta underline underline-offset-2" href={href}>{children}</a> : <span>{children}</span>),
          p: ({ children }) => <p>{withCitations(children, onCite)}</p>,
          li: ({ children }) => <li>{withCitations(children, onCite)}</li>,
        }}
      >
        {text}
      </ReactMarkdown>
    </div>
  )
}

function withCitations(children: React.ReactNode, onCite?: (n: number) => void): React.ReactNode {
  const walk = (node: React.ReactNode): React.ReactNode => {
    if (typeof node !== 'string') return node
    const parts = node.split(/(\[\d{1,3}(?:\s*[,;]\s*\d{1,3})*\])/g)
    return parts.map((p, i) => {
      const m = /^\[(.+)\]$/.exec(p)
      if (!m) return p
      return m[1]!.split(/[,;]/).map((n, j) => {
        const num = Number(n.trim())
        return (
          <button
            key={`${i}-${j}`}
            type="button"
            onClick={() => onCite?.(num)}
            className="mx-0.5 inline-flex h-5 min-w-5 -translate-y-0.5 items-center justify-center rounded-sm bg-marca px-1 align-middle text-[0.72rem] font-bold text-tinta hover:outline hover:outline-1 hover:outline-tinta"
            aria-label={t('Ver fonte {n}', { n: num })}
          >
            {num}
          </button>
        )
      })
    })
  }
  return Array.isArray(children) ? children.map((c, i) => <span key={i}>{walk(c)}</span>) : walk(children)
}
